import {
	CheckCircleOutline,
	ErrorOutline,
	HelpOutline,
	HourglassEmpty,
	SearchOutlined,
	WarningAmberOutlined,
} from "@mui/icons-material";
import { ChipProps } from "@mui/material";
import { RowDataCertificate } from "../types";

export const CERTIFICADO_STATUS_META: Record<
	RowDataCertificate["status"],
	{ label: string; color: ChipProps["color"]; icon: JSX.Element }
> = {
	pendente: { label: "Pendente", color: "default", icon: <HourglassEmpty fontSize="small" /> },
	invalido: { label: "CPF inválido", color: "error", icon: <ErrorOutline fontSize="small" /> },
	buscando: { label: "Buscando...", color: "info", icon: <SearchOutlined fontSize="small" /> },
	nao_encontrado: { label: "Não encontrado", color: "default", icon: <HelpOutline fontSize="small" /> },
	multiplas: { label: "Múltiplas garantias", color: "warning", icon: <WarningAmberOutlined fontSize="small" /> },
	enviado: { label: "Enviado", color: "success", icon: <CheckCircleOutline fontSize="small" /> },
	erro: { label: "Erro", color: "error", icon: <ErrorOutline fontSize="small" /> },
};
